__turbopack_context__.v({
  "className": "geist_mono_b07ec29-module__TLBodq__className",
  "variable": "geist_mono_b07ec29-module__TLBodq__variable",
});
